import { Box, FormControl, Grid } from "@mui/material";
import CardSys from "../../../../components/cardSys";
import TitleDashboard from "../../components/dashBoardTitle";
import { useContext } from "react";
import { AuthContext } from "../../../../contexts/AuthContext";
import SubTitleCard from "../../components/subTitleCard";
import SelectEnterprise from "../../components/selectEnterprise";
import { FilterContext } from "../../contexts/FilterContext";

export default function Filter(){


  const { handleFilter, groupsSelected } = useContext(FilterContext)
    const { user } = useContext(AuthContext)

    return(
        <CardSys>
        <Grid
          container
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <Grid item xs={12} sm={12} md={6} >
            <TitleDashboard  />
          </Grid>
          {user?.id_client != 0 ? (
            <Grid item xs={12} sm={12} md={6}>
              <Box sx={{ display: "flex", alignItems: "center", marginTop: "8px" }}>
                <SubTitleCard>Credor:</SubTitleCard>
                <FormControl
                  size={"small"}
                  sx={{ width: "100%", paddingLeft: "10px" }}
                >
                  <SelectEnterprise
                    value={groupsSelected}
                    color="blackInput"
                    handleSelected={(value) => { handleFilter(value) }}
                  ></SelectEnterprise>
                </FormControl>
              </Box>
            </Grid>
          ) : null}
        </Grid>
      </CardSys >
    )
}